import React from 'react';
import { ModalV2Dialog } from '../../../../core/components/modal-v2';
import { useChangePassword } from '../../api';
import { ChangePasswordForm } from './change-password-form';

interface ChangePasswordModalProps {
  isFirstLogin: boolean;
  onClose: VoidFunction;
  onSuccess: VoidFunction;
}

export const ChangePasswordModal = ({
  isFirstLogin,
  onClose,
  onSuccess,
}: ChangePasswordModalProps): React.ReactElement => {
  const {
    mutate: changePassword,
    isError: isChangePasswordError,
    isLoading: isChangingPassword,
  } = useChangePassword({ onSuccess });

  return (
    <ModalV2Dialog withCloseButton={!isFirstLogin} onClose={onClose} title="Change Password">
      <div className="account-change-password-modal__container">
        {isChangePasswordError && <p className="text-danger">Current password field is not correct</p>}
        {isFirstLogin && (
          <p className="account-change-password-modal__first_login_text">
            Welcome! Since this is your first time logging in, you will need to change your initial password.
          </p>
        )}
        <ChangePasswordForm
          onSubmit={(values) => changePassword({ oldPassword: values.password, newPassword: values.new_password })}
          isSubmitting={isChangingPassword}
          hideCancelBtn={isFirstLogin}
          onCancel={onClose}
        />
      </div>
    </ModalV2Dialog>
  );
};

export default ChangePasswordModal;
